import type { Stop } from "~/features/ftl/shared/ftl-stop";

export function loadValueValidator(value: string): string {
	if (!value) {
		return "Load Value is required.";
	}
	return "";
}

export function weightValidator(value: number): string {
	if (value == undefined || value == null) {
		return "Total Weight is required.";
	}
	if (value <= 0) {
		return "Total Weight must be greater than zero.";
	}
	return "";
}

export function temperatureValidator(value: string): string {
	if (value == undefined || value == null || value === "") {
		return "Temperature is required.";
	}
	return "";
}

export function validateFirstAndLastStopTypes(stops: Stop[]): string {
	if (stops.at(0)?.stopType !== "Pickup") {
		return "The first stop must be a Pickup.";
	}
	if (stops.at(-1)?.stopType !== "Delivery") {
		return "The last stop must be a Delivery.";
	}
	return "";
}

export function validateStopDatesChronological(stops: Stop[]): string {
	for (let i = 0; i < stops.length - 1; i++) {
		const currentStop = stops[i];
		const nextStop = stops[i + 1];

		if (!currentStop?.stopDate || !nextStop?.stopDate) {
			continue;
		}

		const currentDate = new Date(currentStop.stopDate);
		const nextDate = new Date(nextStop.stopDate);

		// Reset time to compare only dates
		currentDate.setHours(0, 0, 0, 0);
		nextDate.setHours(0, 0, 0, 0);

		if (currentDate > nextDate) {
			return `Stop ${i + 1} date (${currentDate.toLocaleDateString()}) must be on or before Stop ${i + 2} date (${nextDate.toLocaleDateString()}). Please ensure stops are in chronological order.`;
		}
	}

	return "";
}
